module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/wifi-icon-c3b5fb9b2e80224d968d28367c7255a0.png";